import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const SmileIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#c99f0e';
  return <Icon name={'support-smile'} size={size} color={color} />;
};

export default React.memo(SmileIcon);
